<template>
  <div class="brands">
    <div class="brands__title">Use brand(s):</div>
    <div v-if="list.length" class="brands__list">
      <span
        v-for="brand in list"
        class="brands__item"
        :key="brand">
        {{ brand }}
      </span>
    </div>
    <div v-else class="no-data">No brands</div>
  </div>
</template>

<script>

export default {
  name: 'BrandList',
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.brands {
  display: flex;
  gap: 8px;
}

.brands__title {
  min-width: 100px;
  padding: 6px 0;
}

.brands__list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.brands__item {
  padding: 5px 16px;
  border: 1px solid var(--border-color);
  border-radius: 20px;
  background: white;
}

.no-data {
  padding: 6px 0;
}
</style>
